module.exports = __webpack_public_path__ + "img/claim-your-corner-bg-merged.06d09000.png";